/**
 * Zod input schemas: hrReports. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
/** Build a vacation-summary PDF for one bucket + year and return it for preview. */
export const VacationSummaryPreviewSchema = z.object({
    groupName: z.string().trim().min(1).max(120),
    year: z.number().int().min(2000).max(2100),
});
/** Build an FTE PDF for one location group + year and return it for preview. */
export const FteReportPreviewSchema = z.object({
    groupName: z.string().trim().min(1).max(120),
    year: z.number().int().min(2000).max(2100),
});
export const FteReportSendNowSchema = z.object({
    /** Also file the documents in the HR vault (the scheduled run always does; ad-hoc default off). */
    saveToVault: z.boolean().optional(),
    /** Bundle names to include in THIS send (default: the bundles marked "in send"). */
    groups: z.array(z.string().trim().min(1).max(120)).max(50).optional(),
});
// ── FTE: record the Kostenstelle status quo of a month from the current user values ──
export const FteKostenstelleSnapshotSetSchema = z.object({
    month: z.string().trim().regex(/^\d{4}-\d{2}$/, 'Month must be YYYY-MM'),
    note: z.string().trim().max(300).optional(),
    /** Replace an existing snapshot for that month (default: refuse). */
    overwrite: z.boolean().optional(),
});
//# sourceMappingURL=hrReports.js.map